<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapPurchaseOrders"
        @select="selectHandle"
        @reset="resetHandle">
      <slot slot="otherBtn">
        <el-button
            v-if="limits.wwflAuth"
            :disabled="selection.length<=0"
            type="primary"
            size="small"
            @click="addMergeOrder">
          委外发料
        </el-button>
        <el-button
            v-if="limits.printAuth"
            :disabled="selection.length<=0"
            type="primary"
            size="small"
            @click="handlePrint">
          采购订单打印
        </el-button>
        <el-button type="primary" size="small" @click="handleExport">导出</el-button>
      </slot>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" label-width="90px" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="采购订单号">
              <el-input
                  v-model.trim="filter.buyOrderNo"
                  type="textarea"
                  :autosize="{ minRows:1, maxRows:6 }"
                  clearable/>
            </el-form-item>
            <el-form-item label="供应商名称">
              <el-input v-model.trim="filter.gysName" clearable/>
            </el-form-item>
            <el-form-item label="供应商编号">
              <el-input v-model.trim="filter.gysCode" clearable/>
            </el-form-item>
            <!--          <el-form-item label="采购组">-->
            <!--            <el-input v-model.trim="filter.buyUserName" clearable/>-->
            <!--          </el-form-item>-->
            <el-form-item label="接货状态">
              <el-select v-model.trim="filter.receiveStatus" placeholder="请选择">
                <el-option label="全部" :value="-1"/>
                <el-option label="供应商未确认" :value="0"/>
                <el-option label="采购驳回" :value="10"/>
                <el-option label="采购未确认" :value="20"/>
                <el-option label="供应商已确认" :value="30"/>
                <el-option label="作废" :value="99"/>
              </el-select>
            </el-form-item>
            <el-form-item label="采购订单类型">
              <el-select v-model.trim="filter.orderType" placeholder="请选择">
                <el-option label="全部" :value="''"/>
                <el-option label="采购订单" :value="'采购订单'"/>
                <el-option label="工序外协采购订单" :value="'工序外协采购订单'"/>
                <el-option label="寄售采购订单" :value="'寄售采购订单'"/>
                <el-option label="退货采购订单" :value="'退货采购订单'"/>
                <el-option label="外协采购订单" :value="'外协采购订单'"/>
              </el-select>
            </el-form-item>
            <el-form-item label="审核状态">
              <el-select v-model.trim="filter.sapStatus" placeholder="请选择">
                <el-option label="全部" :value="null"/>
                <el-option label="未审核" :value="''"/>
                <el-option label="已审核" :value="'X'"/>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="createTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>
            <el-form-item label="SAP审核时间">
              <el-date-picker
                  v-model="auditTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('auditTimeRange', 'auditTimeBegin', 'auditTimeEnd')"/>
            </el-form-item>
            <!--          <el-form-item label="打印状态">-->
            <!--            <el-select v-model.trim="filter.managerID" placeholder="请选择">-->
            <!--              <el-option label="全部" :value="-1"/>-->
            <!--              <el-option label="未打印" :value="0"/>-->
            <!--              <el-option label="已打印" :value="1"/>-->
            <!--            </el-select>-->
            <!--          </el-form-item>-->
          </el-form>
        </div>
      </template>
    </view-table>
    <purchase-order-preview ref="purchasePreview" @save-succee="loadData"/>
    <merge-order-edit ref="mergeOrderEdit" @save-succee="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import PurchaseOrderPreview from "@/views/PurchaseOrderManager/PurchaseOrder/PurchaseOrderPreview";
  import MergeOrderEdit from "@/views/PurchaseOrderManager/PurchaseOrder/MergeOrderEdit";

  export default {
    name: "PurchaseOrderList",
    components: {MergeOrderEdit, PurchaseOrderPreview, viewTable},
    data() {
      return {
        limits: {
          wwflAuth: this.$auth(404),
          printAuth: this.$auth(399),
        },
        filter: {
          buyOrderNo: "",
          gysName: "",
          buyUserName: "",
          receiveStatus: -1,
          managerID: -1,
          gysCode: "",
          orderType: "",
          createTimeBegin: "",
          createTimeEnd: "",
          auditTimeBegin: "",
          auditTimeEnd: "",
          sapStatus:null,
        },
        selection: [],
        materialType: [],
        createTimeRange: [],
        auditTimeRange: [],
        columnsProperty: [
          {
            tooltip: true,
            key: "addDate",
            width: 120,
            align: "center",
          },
          {
            tooltip: true,
            key: "statusName",
            width: 120,
            align: "center",
          },
          {
            tooltip: true,
            key: "buyOrderNo",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.purchasePreview.open(params.row,true);
                    },
                  },
                },
                params.row.buyOrderNo,
              );
            },
          },
          {
            key: "gysName",
            minWidth: 360,
            align: "center",
            tooltip: true,
          },
          {
            key: "gysCode",
            width: 140,
            tooltip: true,
          },
          {
            tooltip: true,
            key: "sapApproveTime",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "managerID",
            width: 100,
            align: "center",
          },
        ],
      };
    },
    mounted() {
    },

    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      addMergeOrder() {
        const gysName = this.selection.every(item => item.gysName === this.selection[0].gysName);
        if (!gysName) {
          this.$confirm("供应商名称不一致,请重新选择", "错误", {
            type: "error",
            showCancelButton: false,
          });
        }
        this.$refs.mergeOrderEdit.open(this.selection);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "materials", row.materialID).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      handleExport() {
        // 导出数据时带上查询参数，不分页
        const params = {
          ...this.filter,
        };

        // 显示加载状态
        this.loading = true;

        // 使用专门的exportFile方法来处理文件导出
        this.$http.exportFile("basic", "sapPurchaseOrders/exportSAPPurchaseOrderVO", params)
          .then(res => {
            this.loading = false;

            // 创建Blob对象
            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            // 创建下载链接
            const link = document.createElement("a");
            const url = window.URL.createObjectURL(blob);

            // 设置下载文件名
            const fileName = `采购订单明细_${new Date().toLocaleDateString().replace(/\//g, "-")}.xlsx`;
            link.href = url;
            link.download = fileName;

            // 触发下载
            document.body.appendChild(link);
            link.click();

            // 清理
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);
            this.$message.success("导出成功");
          })
          .catch(error => {
            this.loading = false;
            console.error("Export error:", error);
            this.$message.error("导出失败，请稍后重试");
          });
      },

      handlePrint() {
        if (this.selection.length === 0) {
          this.$message.error("请选择需要打印的采购合同");
          return;
        }
        const pkId= this.selection[0].pkId;
        const routeUrl = this.$router.resolve({
          path: "/purchaseOrderPrint",
          query: {
            id:pkId,
          },
        });
        window.open(routeUrl.href, "_blank");
      },
    },
  };
</script>
